import { render } from "./PSPDFKit.vue?vue&type=template&id=c813449c&scoped=true"
import script from "./PSPDFKit.vue?vue&type=script&lang=js"
export * from "./PSPDFKit.vue?vue&type=script&lang=js"

import "./PSPDFKit.vue?vue&type=style&index=0&id=c813449c&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c813449c"]])

export default __exports__